import { useEffect, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { getImageUrl } from "src/Common/common";

function BranchDropDown({ branches, selectedBranch, branchClicked }) {
  const [isDropDownShown, setIsDropDownShown] = useState(false);

  return (
    <div className="w-full py-[5px] ">
      <OutsideClickHandler
        onOutsideClick={() => {
          setIsDropDownShown(false);
        }}
      >
        <div
          onClick={() => setIsDropDownShown(!isDropDownShown)}
          className="w-full flex items-center justify-between cursor-pointer relative"
        >
          <span className="font-OpenSansRegular text-[11px] font-[400] h-full pl-[15px]">
            {selectedBranch ? selectedBranch.name : "Select branch"}
          </span>
          <img src={getImageUrl("/images/common/arrow-down.png")} />

          {isDropDownShown && (
            <div className="w-full absolute py-2 max-h-[160px] overflow-auto shadow-lg top-[30px] left-0 z-10 bg-white flex flex-col justify-between border-[1px]">
              {branches &&
                branches.map((branch, index) => (
                  <div
                    onClick={() => branchClicked(branch)}
                    key={index}
                    className={`w-full min-h-[20px] flex items-center px-3 py-2 rounded transition-colors duration-150 ${
                      selectedBranch && selectedBranch.name === branch.name ? "bg-slate-300" : "hover:bg-slate-400"
                    }`}
                  >
                    <p className="font-OpenSansRegular text-[11px] text-inputEmailTitle font-[400]">{branch.name}</p>
                  </div>
                ))}
            </div>
          )}
        </div>
      </OutsideClickHandler>
    </div>
  );
}

export default BranchDropDown;
